import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Table from '../../../components/table/table.jsx';
import { PopupService } from '../../../services/popup_service.jsx';
import NotificationPopup from '../../../components/popups/notification_popup.jsx';
import { NotificationButtons } from "../../../components/popups/popup_constants.js";
import { createStructuredSelector } from 'reselect';
import { selectCards, selectCardsFilter } from '../../../state/selectors/cards.js';
import cardService from '../../../services/cardService.js';
import { useHistory } from 'react-router';
import { useLocalization } from '../../../hooks/useLocalization.js';
import { hasModuleAccess } from '../../../services/accessService.js';
import cardTypes from '../../../constants/cardTypes.js';
import CancellationToken from '../../../utils/cancelationToken.js';
import { useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import { dispatch } from '../../../state/store.js';
import { resetCardsFilter } from '../../../state/ducks/cards.js';
import { utils } from '../../../utils/utils.js';

const Columns = [
    {
        header: "Cards.cardNumber",
        name: "cardNumberInternal",
        sortProperty: "CardNumberInternal",
        dataType: "int",
        leadingZeroMax: 6
    },
    {
        header: "Cards.userName",
        name: "userName",
        sortProperty: "UserName"
    },
    {
        header: "Cards.car",
        name: "car",
        sortProperty: "Car"
    },
    {
        header: "Cards.description",
        name: "description",
        sortProperty: "Description"
    }
];

const mapStateToProps = () => {
    return createStructuredSelector({
        cards: selectCards(),
        filter: selectCardsFilter()
    });
};

const CardList = (props) => {
    const { cards, filter } = props;
    const history = useHistory();
    const { t } = useLocalization();

    const cancelationTokenRef = useRef(null);
    const timerRef = useRef(null);
    const filterPrevRef = useRef({});

    const [tableId, setTableId] = useState(utils.generateUuid());


    useEffect(() => {
        setTableId(utils.generateUuid());
        dispatch(resetCardsFilter());
        return () => {
            timerRef.current && clearTimeout(timerRef.current);
            cancelationTokenRef.current && cancelationTokenRef.current.cancel();            
        }
    }, [])

    useEffect(() => {
        if(JSON.stringify(filter) !== JSON.stringify(filterPrevRef.current)){
            getNewData(filter);
        }
    }, [filter])

    const getNewData = async (filter) => {
        try {
            cancelationTokenRef.current && cancelationTokenRef.current.cancel();
            cancelationTokenRef.current = new CancellationToken();
            timerRef.current && clearTimeout(timerRef.current);
            filterPrevRef.current = filter;
            await getData(filter);
        } catch (error) { 
        } finally {
            timerRef.current = setTimeout(() => getNewData(filter), 5000);
        }
    }

    const getData = async (applyFilter) => {
        applyFilter = applyFilter ? applyFilter : filter;
        if (!applyFilter) return;
        await cardService.getCardsAsync(applyFilter, cancelationTokenRef.current);
    }

    const addCard = () => {
        history.push("/cards/cars/addCard", {cardType: cardTypes.AVTO});
    }

    const editCard = (card) => {
        history.push("/cards/cars/editCard/" + card.cardId, {cardType: cardTypes.AVTO});
    }

    const removeCardAction = (card) => {
        const header = t('Cards.removeCardPopupHeader');
        const message = t('Cards.removeCardPopupMessage')
            .replace("{card number}", card.cardNumberInternal);
        const element = React.createElement(NotificationPopup,
            {
                header: header,
                message: message,
                buttons: [NotificationButtons.OK, NotificationButtons.CANCEL],
                submitAction: () => {
                    cardService.removeCardAsync(card);
                }
            });
        PopupService.showPopup(element);
    }

    const CardsModelFilter = {
        cardNumber: {
            name: "cardNumberInternal",
            type: "int",
            header: t('Cards.cardNumber'),
            value: filter.modelFilter.cardNumberInternal
        },
        car: {            
            name: "car",
            type: "string",
            header: t("Cards.car"),
            value: filter.modelFilter.car
        }
    };

    return (
        <div>
            <Table 
                id={tableId} 
                settings={{                
                    columns: Columns,
                    items: cards,
                    itemsFilter: {...filter, filterProps: cloneDeep(CardsModelFilter) },
                    isEditable: hasModuleAccess('Cards', 2),
                    canBeRemoved: hasModuleAccess('Cards', 2),
                    getItemsFunction: getNewData,
                    addItemFunction: hasModuleAccess('Cards', 2) ? addCard : undefined,
                    editItemFunction: editCard,
                    removeItemFunction: removeCardAction,
                    keyField: "cardId"
                }} />
        </div>
    );
}


export default connect(mapStateToProps)(CardList);